import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { AdUnitViewabilityToolsDTO } from '../types/adUnitViewabilityToolsDTO'

export const AD_UNIT_VIEWABILITY_TOOLS_FRAGMENT: TypedDocumentNode<AdUnitViewabilityToolsDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment AdUnitViewabilityToolsFragment on AdUnitViewabilityTool {
    adHoldingAutoEnabled
    adHoldingEnabled
    adUnitId
    autoDisabled
    createdAt
    customizeLazyLoadingParametersEnabled
    fieldAlerts {
      ...AlertFragment
    }
    gamAdRequestMargin
    id
    kvTargetingAndPrebidAuction
    lazyLoadingAutoEnabled
    lazyLoadingEnabled
    lazyLoadTargetingPrebidAuctionEnabled
    mobileScaling
    scrollSlowingAutoEnabled
    scrollSlowingEnabled
    updatedAt
    viewabilityToolsEnabled
  }
`
